import { render, staticRenderFns } from "./PromoCreationModal.vue?vue&type=template&id=602510d2"
import script from "./PromoCreationModal.vue?vue&type=script&lang=js"
export * from "./PromoCreationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports